import http from 'conversations-http/clients/http';
export const getZorseInboxes = () => http.get('conversations/taxonomy/v1/inbox');